module.exports = __webpack_public_path__ + "static/media/undraw-dark-alley-hl-3-o.963412fb.svg";